import { useQuery } from "convex/react";
import { useEffect, useState } from "react";

import { type ErrorInfo, ErrorInfoDisplay } from "@/components/Notifications/ErrorInfoDisplay";
import { SendTestNotificationButton } from "@/components/Notifications/SendTestNotificationButton";
import { SubscribeButton } from "@/components/Notifications/SubscribeButton";
import { TimeSelector } from "@/components/Notifications/TimeSelector";
import { UnsubscribeButton } from "@/components/Notifications/UnsubscribeButton";
import { usePushManager } from "@/hooks/usePushManager";
import { api } from "@convex/_generated/api";

export const NotificationStatus = () => {
  const pushManager = usePushManager(); // If undefined, push notifications are not supported in the current context.
  const [currentSubscription, setCurrentSubscription] = useState<
    PushSubscription | null | undefined
  >(undefined); // undefined = loading; null = done loading, but no subscription.
  const [errorInfo, setErrorInfo] = useState<ErrorInfo | null>(null);

  // Update the current subscription when the push manager is available.
  useEffect(() => {
    void (async () => {
      // If there is no push manager, keep currentSubscription as undefined.
      if (pushManager) {
        const existingSubscription = await pushManager.getSubscription();
        setCurrentSubscription(existingSubscription);
        console.log("existingSubscription", existingSubscription);
      }
    })();
  }, [pushManager]);

  // undefined = loading
  // null = the current subscription is not in the database.
  const currentSavedSubscription = useQuery(
    api.notificationSubscriptions.get,
    currentSubscription === undefined
      ? "skip"
      : {
          pushSubscription: JSON.stringify(currentSubscription),
        }
  );

  return (
    <section>
      <h2 className="text-lg font-semibold mb-2">Notifications</h2>
      {!pushManager || !("Notification" in window) ? (
        <>
          <p className="text-sm text-gray-600 mb-3">This browser doesn't support notifications.</p>
          <p className="text-sm text-gray-600">
            In order to enable notifications on an iPhone or iPad, you first must add 17reviews to
            your home screen, and launch the app from there.
          </p>
        </>
      ) : currentSubscription === undefined || currentSavedSubscription === undefined ? (
        <p className="text-sm text-gray-600 mb-3">Loading</p>
      ) : currentSubscription && currentSavedSubscription ? (
        <>
          <TimeSelector currentSavedSubscription={currentSavedSubscription} />
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center mt-4">
            <SendTestNotificationButton currentSubscription={currentSubscription} />
            <UnsubscribeButton
              currentSubscription={currentSubscription}
              setCurrentSubscription={setCurrentSubscription}
            />
          </div>
        </>
      ) : (
        <>
          <p className="text-sm text-gray-600 mb-3">
            If you want, 17reviews can send you a daily reminder to about cards that are due for
            review.
          </p>
          <div>
            <SubscribeButton
              pushManager={pushManager}
              setCurrentSubscription={setCurrentSubscription}
              setErrorInfo={setErrorInfo}
            />
          </div>
          {errorInfo && <ErrorInfoDisplay errorInfo={errorInfo} />}
        </>
      )}
    </section>
  );
};
